import { onError } from '@apollo/client/link/error';
import type { GraphQLFormattedError } from 'graphql';

import { APPLIED_ROUTE } from 'src/const/app';
import { navigateToUrl } from 'src/utils';

import { logError } from '../modules/error-logger/browserLog';

enum GraphQLErrorCode {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
}

export const hasUnauthError = (
  graphQLErrors: readonly GraphQLFormattedError[],
) =>
  graphQLErrors.some(
    (err) => err?.extensions?.code === GraphQLErrorCode.UNAUTHENTICATED,
  );

export const createOnErrorLink = (language: string) =>
  onError((args) => {
    const { graphQLErrors: unsafeGraphqlErrors } = args;
    const graphQLErrors = unsafeGraphqlErrors || [];

    if (!hasUnauthError(graphQLErrors)) {
      graphQLErrors.forEach((error) => {
        logError(
          {
            type: 'graphql-error',
            message: error.message,
          },
          {
            graphQLErrors,
          },
        );
      });
      return;
    }

    const appliedRoute =
      language === 'en' ? `${APPLIED_ROUTE}` : `/${language}${APPLIED_ROUTE}`;

    navigateToUrl(`/oauth/login/?returnUrl=${appliedRoute}`);
  });
